import { useEffect, useState, useCallback, useMemo } from 'react';
import { Breadcrumb, Button, Col, Form, Input, Row, Select, message, Table, Space, Tooltip, Typography, Spin} from 'antd';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { PlusOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { Option } from 'antd/es/mentions';
import TextArea from 'antd/es/input/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import {
  finalizeBundleOutward,
  fetchBundleOutWardListByItem,
  resetBundleOutWardList,
  createBundleOutWard,
  fetchWorkOrderList,
  fetchWorkOrderItemById,
  resetWorkOrderList,
} from '../../slices/warehouse-bundle-outward';
import { fetchVehicleList, resetVehicleList } from '../../slices/vehicle';
import dayjs from 'dayjs';

export default function AddWarehouseBundleOutWard() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [workOrderPage, setWorkOrderPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const PAGE_SIZE = 100;
  const [loadingWorkOrders, setLoadingWorkOrders] = useState(false);
  const [loading, setLoading] = useState(true);
  const [workOrderItem, setWorkOrderItem] = useState([]);
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(20);
  const {
    list: workOrderList = [],
    status,
    totalRecord,
  } = useSelector(state => state.warehouseBundleOutward);
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bundleOutwardId, setBundleOutwardId] = useState(null);
  const [disableCheck, setDisableCheck] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [selectedShift, setSelectedShift] = useState('');
  const [shiftmode, setShiftMode] = useState(false);
  const [vehicleSearchValue, setVehicleSearchValue] = useState('');
  const [vehicleHasMore, setVehicleHasMore] = useState([]);
  const [vehicleFetching, setVehicleFetching] = useState(false);
  const { list: vehicleList = [], status: vehicleStatus } = useSelector(state => state.vehicle);

  const getCurrentShift = () => {
    const now = dayjs().tz('Asia/Kolkata');

    const startA = now.set('hour', 8).set('minute', 0).set('second', 0);
    const endA = now.set('hour', 20).set('minute', 0).set('second', 0);

    if (now.isSameOrAfter(startA) && now.isBefore(endA)) {
      return 'A';
    }

    return 'B';
  };

  useEffect(() => {
    const currentShift = getCurrentShift();
    setSelectedShift(currentShift);
    form.setFieldsValue({
      shift: currentShift,
    });
  }, []);

  useEffect(() => {
    if (workOrderList.length === 0 && !loadingWorkOrders) {
      setLoadingWorkOrders(true);
      dispatch(
        fetchWorkOrderList({
          page: 1,
          pagesize: PAGE_SIZE,
          search: searchText,
        }),
      )
        .unwrap()
        .finally(() => setLoadingWorkOrders(false));
      setWorkOrderPage(1);
    }
  }, [dispatch, workOrderList.length, searchText]);

  const [shiftModes, setShiftModes] = useState([
    { title: 'A', value: 'A' },
    { title: 'B', value: 'B' },
  ]);
  const handleChangeShift = e => {
    setShiftMode(e);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => {
      setSelectedRowKeys(selectedRowKeys);
      setDisableCheck(selectedRowKeys.length !== 0);
    },
    getCheckboxProps: record => ({
      disabled: record.added_bundles === 0,
    }),
  };
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [selectedWorkOrderBundles, setSelectedWorkOrderBundles] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetWorkOrderList());
    dispatch(resetBundleOutWardList());
    setWorkOrderPage(1);
    setHasMore(true);
    return () => {
      dispatch(resetWorkOrderList());
      dispatch(resetBundleOutWardList());
    };
  }, [dispatch, searchText, orderBy]);

  useEffect(() => {
    setHasMore(workOrderList.length < totalRecord);
  }, [workOrderList, totalRecord]);

  const handleFinalizeBundle = () => {
    const values = {
      workorder_detail_id: selectedRowKeys,
      outward_id: Number(bundleOutwardId),
    };
    dispatch(finalizeBundleOutward({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        message.success('Bundle OutWard Finalize Successfully!');
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };
  const getBundleOutwardList = async (workOrderId, bundleOutwardId) => {
    try {
      const response = await dispatch(
        fetchBundleOutWardListByItem({
          page: 1,
          pagesize: 1000,
          workOrderId,
          bundleOutwardId,
        }),
      ).unwrap();

      const transformedData = response?.results?.data.map((item, index) => ({
        ...item,
        SrNo: index + 1,
      }));

      setSelectedWorkOrderBundles(transformedData);
    } catch (error) {
      console.error('Error fetching bundle outward list:', error);
      setSelectedWorkOrderBundles([]);
    }
  };

  const handleFinish = async values => {
    setBtnLoading(true);

    dispatch(createBundleOutWard({ values }))
      .unwrap()
      .then(result => {
        const newBundleOutwardId = result?.data?.id;

        setBtnLoading(false);
        message.success('Bundle OutWard Created Successfully!');
        getBundleOutwardList(values?.workorder, newBundleOutwardId);

        setBundleOutwardId(newBundleOutwardId);
        setIsSuccess(true);
        setIsButtonDisabled(true);

        dispatch(resetBundleOutWardList());
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPageSize(pagination.pageSize);
  };
  const handleAdd = data => {
    navigate(
      `/add-warehouse-bundle-for-outward/${data.workorder_detail_id}/${bundleOutwardId}`,
    );
  };
  

  const handlePrint = () => {
    window.open(`/warehouse-print-draft-bundle-outword/${bundleOutwardId}`);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: '80px',
    },
    {
      title: 'Item Description',
      dataIndex: 'item_description',
      key: 'workorder_die_number',
      width: '350px',
      render: (_, record) => record.item_description,
    },
    {
      title: 'Total Bundles',
      dataIndex: 'total_bundle',
      key: 'total_bundle',
    },

    {
      title: 'Total Pieces',
      dataIndex: 'total_piece',
      key: 'total_piece',
    },
    {
      title: 'Total Weight(kg)',
      dataIndex: 'total_weight',
      key: 'total_weight',

    },
    {
      title: 'Added Bundles',
      dataIndex: 'added_bundles',
      key: 'added_bundles',
    },
    {
      title: 'Added Pieces',
      dataIndex: 'added_bundles_pieces',
      key: 'added_bundles_pieces',
    },

    {
      title: 'Added Weight(kg)',
      dataIndex: 'added_bundles_weight',
      key: 'added_bundles_weight',

    },
    {
      title: 'Ready Bundles',
      dataIndex: 'ready_bundles',
      key: 'ready_bundles',
    },
    {
      title: 'Ready Pieces',
      dataIndex: 'ready_bundles_pieces',
      key: 'ready_bundles_pieces',
    },

    {
      title: 'Ready Weight(kg)',
      dataIndex: 'ready_bundles_weight',
      key: 'ready_bundles_weight',

    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '200px',
      key: 'status',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tooltip placement="top" title={'Add Bundle For OutWard'}>
            <span onClick={() => handleAdd(record)}>
              <PlusOutlined style={{ cursor: 'pointer' }} />
            </span>
          </Tooltip>
          {/* <Tooltip placement="top" title={'Delete'}>
            <DeleteOutlined danger style={{cursor: 'pointer'}} />
          </Tooltip> */}
        </Space>
      ),
    },
  ];
  // const handleWorkOrderSelect = async workOrderId => {
  //   setWorkOrderItem([]);
  //   setSelectedWorkOrderBundles([]);

  //   const selectedWorkOrder = workOrderList.find(wo => wo.id === workOrderId);
  //   setSelectedWorkOrder(selectedWorkOrder);
  //   form.setFieldsValue({
  //     workorder_detail: [],
  //     remarks: null,
  //     transporter_name: null,
  //     dispatch_to: 'Customer',
  //     // shift: null,
  //     vehicle_no: null,
  //   });
  //   setIsSuccess(false);
  //   try {
  //     const response = await dispatch(
  //       fetchWorkOrderItemById({
  //         id: workOrderId,
  //         page: 1,
  //         pagesize: 10,
  //         search: '',
  //         ordering: '',
  //       }),
  //     );
  //     const uniqueItems = Array.from(
  //       new Set(response.payload.map(item => item.id)),
  //     ).map(id => response.payload.find(item => item.id === id));

  //     setWorkOrderItem(uniqueItems);
  //   } catch (error) {
  //     console.error('Error fetching work order items:', error);
  //     setWorkOrderItem([]);
  //   }
  // };

  // const handleWorkOrderSelectItem = async selectedId => {
  //   const selectedItem = workOrderItem.find(item => item.id === selectedId);
  // };

  const filteredWorkOrderList = useMemo(() => {
    const uniqueWorkOrders = Array.from(
      new Map(workOrderList.map(wo => [wo.id, wo])).values(),
    );
    if (!searchText) return uniqueWorkOrders;
    return uniqueWorkOrders.filter(
      wo =>
        wo.order_no?.toLowerCase().includes(searchText.toLowerCase()) ||
        wo.purchase_order_no?.toLowerCase().includes(searchText.toLowerCase()) ||
        wo.bill_to?.customer_name?.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [workOrderList, searchText]);

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const debouncedSearch = useCallback(
    debounce(value => {
      setSearchText(value);
      setWorkOrderPage(1);
      setHasMore(true);
      dispatch(resetWorkOrderList());
      dispatch(
        fetchWorkOrderList({
          page: 1,
          pagesize: PAGE_SIZE,
          search: value,
        }),
      );
    }, 500),
    [dispatch],
  );

  const handleSearch = useCallback(
    value => {
      debouncedSearch(value);
    },
    [debouncedSearch],
  );

  const handleScroll = useCallback(
    e => {
      const target = e.target;
      const atBottom =
        target.scrollTop + target.offsetHeight >= target.scrollHeight - 5;
      if (atBottom && hasMore && !loadingWorkOrders) {
        setLoadingWorkOrders(true);
        const nextPage = workOrderPage + 1;
        dispatch(
          fetchWorkOrderList({
            page: nextPage,
            pagesize: PAGE_SIZE,
            search: searchText,
          }),
        )
          .unwrap()
          .finally(() => setLoadingWorkOrders(false));
        setWorkOrderPage(nextPage);
      }
    },
    [dispatch, hasMore, workOrderPage, searchText, loadingWorkOrders],
  );

  const workOrder = useMemo(
    () => (
      <Form.Item
        name="workorder"
        label="Select Work Order"
        rules={[{ required: true, message: 'Please select work order' }]}
      >
        <AutoOpenSelect
          placeholder="Order Date - Order No - PO Number - PO Date - Customer Name"
          //onChange={handleWorkOrderSelect}
          showSearch
          onSearch={handleSearch}
          onPopupScroll={handleScroll}
          optionFilterProp="label"
          optionLabelProp="label"
          notFoundContent={
            loadingWorkOrders ? <Spin size="small" /> : 'No work orders found'
          }
          style={{ width: '100%' }}
          filterOption={false}
        >
          {filteredWorkOrderList.map(wo => (
            <Option
              key={wo.id}
              value={wo.id}
              label={`${dayjs(wo?.order_date).format('DD/MM/YYYY')} - ${wo?.order_no} | ${wo?.purchase_order_no} - ${dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')} | ${wo?.bill_to?.customer_name}`}
              disabled={['W/o create'].includes(wo.status)}
            >
              <div
                title={`${dayjs(wo?.order_date).format('DD/MM/YYYY')} - ${wo?.order_no} | ${wo?.purchase_order_no} - ${dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')} | ${wo?.bill_to?.customer_name}`}
              >
                <strong>
                  {dayjs(wo?.order_date).format('DD/MM/YYYY')} | {wo?.order_no} |
                </strong>
                <br />
                {'PO No.: '} {wo?.purchase_order_no} | <br /> {'PO Date.: '}
                {dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')} |{' '}
                {wo?.bill_to?.customer_name}
              </div>
            </Option>
          ))}
        </AutoOpenSelect>
      </Form.Item>
    ),
    [handleSearch, handleScroll, loadingWorkOrders, filteredWorkOrderList],
  );

  // const workOrderFormItem = (
  //   <Form.Item name="workorder_detail" label="">
  //     <label className="clmlbl">Work Order Item</label>
  //     <Select
  //       placeholder="Select Work Order"
  //       onChange={handleWorkOrderSelectItem}
  //       showSearch
  //       optionFilterProp="children"
  //       rules={[{ required: true, message: 'Please Select Work Order!' }]}
  //       style={{ width: '100%' }}
  //     >
  //       {Array.isArray(workOrderItem) && workOrderItem.length > 0 ? (
  //         workOrderItem.map(wo => {
  //           return (
  //             <Option
  //               key={wo.id}
  //               value={wo.id}
  //               disabled={wo.bundle_out === false}
  //             >
  //               {`${wo.die_profile?.die_number || 'N/A'} - ${wo.length || 'N/A'} mm - 
  //       Packed: ${wo.packed_weight || '0.000'} kg - Dispatched: ${wo.dispatched || '0.000'} kg - 
  //       Net Order: ${wo.net_weight || '0.000'} kg - Temper: ${wo.temper?.name || 'N/A'} - 
  //       Code: ${wo.temper?.code || 'N/A'}`}
  //             </Option>
  //           );
  //         })
  //       ) : (
  //         <Option disabled>No items found</Option>
  //       )}
  //     </Select>
  //   </Form.Item>
  // );

  const loadVehicleTypes = async (page) => {
      if (vehicleFetching || !vehicleHasMore) return;
  
      setVehicleFetching(true);
      const response = await dispatch(
        fetchVehicleList({
          page,
          pagesize: 20
        })
      );
      console.log(response?.payload);
      if (response?.payload?.next === null) {
        console.log("no more data");
        setVehicleHasMore(false);
      }
      setVehicleFetching(false);
    };
  
    const debouncedVehicleSearch = useMemo(() => debounce((value) => {
      setVehicleSearchValue(value);
      // setWorkOrderPage(1);
      setVehicleHasMore(true);
    }, 500), []); // 300ms delay for work order search
  
    const handleVehicleSearch = useCallback((value) => {
      setVehicleSearchValue(value);
      debouncedVehicleSearch(value);
    }, [debouncedVehicleSearch]);
  
    const handleVehicleDropdownScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - scrollTop <= clientHeight + 10) {
        loadVehicleTypes(1);
      }
    };
  
    useEffect(() => {
      dispatch(resetVehicleList());
      loadVehicleTypes(1);
    }, []);

  return (
    <>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2>Add Warehouse Bundle OutWard</h2>
              <div className="bredcrumbwrp">
                <Link
                  className="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    {
                      title: (
                        <Link to="/warehouse-bundle-outward">
                          Warehouse Bundle OutWard
                        </Link>
                      ),
                    },
                    { title: 'Add Warehouse Bundle OutWard' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Link>
                  <Tooltip title="Finalize">
                    <Button
                      disabled={!disableCheck}
                      style={{ backgroundColor: '#e0f8e0' }}
                      onClick={() => handleFinalizeBundle()}
                    >
                      Finalize Outward
                    </Button>
                  </Tooltip>
                </Link>
                <Link>
                  <Tooltip title="Print Draft">
                    <Button
                      style={{ backgroundColor: '#FFFBF6' }}
                      onClick={() => handlePrint()}
                    >
                      Print Draft Outward
                    </Button>
                  </Tooltip>
                </Link>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          autoComplete="off"
          form={form}
          onFinish={handleFinish}
          initialValues={{ dispatch_to: 'Customer' }}
        >
          <Row gutter={16}>
            <Col xs={24} sm={9} xl={7} xxl={5}>
              {workOrder}
            </Col>

            <Col xs={24} sm={7} xl={5} xxl={3}>
            <Form.Item
                            name="vehicle_no"
                            label="Vehicle Number"
                            rules={[{ required: true, message: 'Please Select Vehicle!' }]}
                          >
                            <Select
                              placeholder="Vehicle No"
                              onPopupScroll={handleVehicleDropdownScroll}
                              onSearch={handleVehicleSearch}
                              searchValue={vehicleSearchValue}
                              showSearch
                              filterOption={false}
                              style={{ width: '100%' }}
                              optionLabelProp="label"
                              notFoundContent={
                                vehicleFetching || vehicleStatus !== 'succeeded' ? (
                                  <div style={{ textAlign: 'center' }}>
                                    <Spin size="small" />
                                  </div>
                                ) : vehicleList.length === 0 ? (
                                  <div style={{ textAlign: 'center', padding: '8px' }}>
                                    No vehicle found
                                  </div>
                                ) : null
                              }
                              loading={vehicleFetching || vehicleStatus !== 'succeeded'}
                            >
                              {vehicleList?.map(vh => (
                                <Option key={vh.id} value={vh.id} label={vh.vehicle_no}>{vh?.vehicle_no}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
              {/* <Form.Item
                name="vehicle_no"
                label="Vehicle Number"
                rules={[
                  {
                    pattern: /^[A-Za-z0-9 ]+$/,
                    message: 'Only letters, numbers, and spaces are allowed',
                  },
                  {
                    required: true,
                    message: 'Please enter vehicle number',
                  }
                ]}
              >
                <Input placeholder="Enter Vehicle Number" />
              </Form.Item> */}
            </Col>

            <Col xs={24} sm={8} xl={6} xxl={4}>
              <Form.Item
                name="transporter_name"
                label="Transporter Name"
                rules={[
                  {
                    required: true,
                    message: 'Please enter transporter name',
                  }
                ]}
              >
                <Input
                  placeholder="Enter Transporter Name"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Form.Item
                label="Shift"
                name="shift"
                rules={[{ required: true, message: 'Please select shift' }]}
              >
                <Select
                  disabled
                  placeholder="Select Shift"
                  onChange={handleChangeShift}
                  options={shiftModes}
                  value={selectedShift}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} xl={6} xxl={4}>
              <Form.Item name="remarks" label="Remarks">
                <TextArea placeholder="Enter Remarks" />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end mb-3">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={btnLoading}
              disabled={isButtonDisabled}
            >
              Add New Outward
            </Button>
          </div>
        </Form>
        {isSuccess ? (
          <>
            <Typography.Title level={4} style={{ textAlign: 'center' }}>
              Work Order Items
            </Typography.Title>
            <Table
              rowKey="workorder_detail_id"
              rowSelection={rowSelection}
              columns={columns}
              dataSource={selectedWorkOrderBundles || []}
              pagination={{
                defaultCurrent: page,
                defaultPageSize: pagesize,
                showTotal: total => `Total ${total} items`,
                showSizeChanger: true,
              }}
              onChange={handleTableChange}
              pageSizeOptions={['20', '50', '100']}
              loading={status === 'loading'}
              scroll={{ x: '600px' }}
            />
          </>
        ) : null}
      </div>
    </>
  );
}
